import { createNamespacedHelpers } from 'vuex'
import * as USER from 'src/api/dev/user'
import * as T from './types'

const module = {
    namespaced: true,
    state: {
        current: {
            account: '',
            id: '',
            email: '',
            remark: '',
            mobile: '',
            faked_pwd: '123456789'
        },
        domainUserList: [],
        total: 0,
        timestamps: {
            listUsers: ''
        }
    },
    mutations: {
        [T.CURRENT_USER](state, data) {
            state.current = Object.assign({ faked_pwd: '123456789' }, data)
        },
        [T.UPDATE_EMAIL](state, { email }) {
            state.current.email = email
        },
        [T.SET_DOMAIN_USERS_LIST](state, { items, total }) {
            state.timestamps.listUsers = +new Date()
            state.domainUserList = items
            state.total = total
        },
        [T.ADD_USER_ITEMS](state, payload) {
            state.domainUserList = payload.concat(state.domainUserList)
        },
        [T.DELETE_USER_ITEM](state, payload) {
            state.total -= 1
            state.domainUserList = state.domainUserList.filter(
                user => user.user_account_id !== payload
            )
        }
    },
    actions: {
        async getCurrentUser({ commit }) {
            // faked_password 用于占位显示
            commit(T.CURRENT_USER, await USER.detail())
        },
        async updateEmail({ commit }, { email }) {
            await USER.updateEmail(email)
            commit(T.UPDATE_EMAIL, { email })
        },
        async getDomainUserList({ commit }, params) {
            commit(T.SET_DOMAIN_USERS_LIST, await USER.getDomainUsers(params))
        },
        async addUsers({ commit }, { role, accountList, accountDict }) {
            const accounts = accountList.map(userCode => ({
                account: `${userCode.replace(/@mysoft$/, '')}@mysoft`,
                name: accountDict[`${userCode.replace(/@mysoft$/, '')}`]
            }))
            await USER.addDomainUser({ role, accounts })
            commit(
                T.ADD_USER_ITEMS,
                accountList.map(account => ({
                    role,
                    account: `${account}@mysoft`,
                    created_on: new Date().toLocaleString()
                }))
            )
        },
        async deleteUser({ commit }, accountId) {
            await USER.deleteDomainUser(accountId)
            commit(T.DELETE_USER_ITEM, accountId)
        }
    },
    getters: {}
}
const { mapState, mapActions, mapGetters, mapMutations } = createNamespacedHelpers('user')

export { mapState, mapActions, mapGetters, mapMutations }

export default module
